export const tags = [
  {
    name: 'Хорошие новости',
  },
  {
    name: 'ЛГБТ+',
  },
  {
    name: 'Война',
  },
  {
    name: 'Экология',
  },
  {
    name: 'Миграция',
  },
  {
    name: 'Репрессии',
  },
  {
    name: 'Образование',
  },
  {
    name: 'Права народов',
  },
  {
    name: 'Права женщин',
  },
  {
    name: 'Трудовые права',
  },
  {
    name: 'Сопротивление',
  },
  {
    name: 'Выборы',
  },
];
